import * as S from '../PriceGuideCard.style';
import { isLogin } from '../../../../utils/auth';
import React, { useEffect, useState, useMemo, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { PlanItem } from '../../../pay/paymentPlan';
import RegionSelectModal from './RegionSelectModal';
import { useModal } from '../../../../context/ModalContext';
import { scrollToElement } from '../../../../utils/scrollToElement';
import { premiumBenefit } from './data';

interface IFormData {
  P_INI_PAYMENT: string;
  P_MID: string;
  P_OID: string;
  P_AMT: number;
  P_GOODS: string;
  P_UNAME: string;
  P_NEXT_URL: string;
  P_RESERVED: string;
  url: string;
}

interface PremiumProps {
  plans: PlanItem[];
  month: number;
  recommend?: boolean;
}

const Premium = ({ plans, month, recommend }: PremiumProps) => {
  const navigate = useNavigate();
  const { modalDispatch } = useModal();

  const [selectedPlan, setSelectedPlan] = useState<PlanItem>(plans[0]);
  const [openDropdown, setOpenDropdown] = useState(false);

  const originalPlan = useMemo(() => {
    const sameIdPlans = plans.filter(
      (p) => p.plan_name === selectedPlan.plan_name,
    );
    if (sameIdPlans.length === 0) return null;

    const maxObj = sameIdPlans.reduce((max, cur) =>
      cur.plan_prc > max.plan_prc ? cur : max,
    );

    if (maxObj.plan_prc <= selectedPlan.plan_prc) return null;

    return maxObj;
  }, [plans, selectedPlan]);

  useEffect(() => {
    if (plans.length > 0) {
      setSelectedPlan(plans[0]);
    }
  }, [plans]);

  const naver_script = () => {
    if (window.wcs) {
      if (!window.wcs_add) window.wcs_add = {};
      window.wcs_add['wa'] = 's_2489d344048e';
      const _conv = {
        type: 'begin_checkout',
        items: [
          {
            id: selectedPlan?.plan_id,
            name: selectedPlan?.name,
            payAmount: selectedPlan?.plan_prc,
          },
        ],
      };
      window.wcs.trans(_conv);
    }
  };

  return (
    <S.CardContainer $recommend={recommend}>
      {recommend && <S.Badge>추천</S.Badge>}
      <S.CardHeader>
        <S.CardTitleContainer>
          <S.CardTitle>프리미엄</S.CardTitle>
          <S.ViewMore onClick={() => scrollToElement('compare', 56)}>
            자세히보기
          </S.ViewMore>
        </S.CardTitleContainer>
        <S.PriceWrapper>
          <S.Price>
            {selectedPlan.plan_prc.toLocaleString()}원<span>/{month}개월</span>
          </S.Price>
          {selectedPlan.is_discount === 'Y' && (
            <S.OriginPriceBox>
              <S.OriginPricePercent>50%</S.OriginPricePercent>
              특별할인가
              <S.OriginPrice>
                {originalPlan?.plan_prc.toLocaleString()}원
              </S.OriginPrice>
            </S.OriginPriceBox>
          )}
        </S.PriceWrapper>

        <S.DropdownButton onClick={() => setOpenDropdown(true)}>
          <S.DropdownButtonText>
            {selectedPlan.plan_name}{' '}
            {selectedPlan.is_discount === 'Y' && '특별할인'}
          </S.DropdownButtonText>
          <img src="/assets/images/arrow/arrow-down-alternative.svg" alt="" />
        </S.DropdownButton>
      </S.CardHeader>
      <S.CardBottom>
        <S.CardContent>
          {premiumBenefit.map(({ text, number }, idx) => (
            <S.PlanDescription key={idx}>
              <img src="/assets/images/check/check-black.svg" alt="" />
              <S.PlanDescriptionText>{text}</S.PlanDescriptionText>
              <S.PlanDesriptionBold>{number}</S.PlanDesriptionBold>
            </S.PlanDescription>
          ))}
        </S.CardContent>
        <S.ConfirmButton
          $recommend={recommend}
          onClick={() => {
            if (!isLogin()) {
              modalDispatch({ type: 'USER_ALERT', payload: 'guest' });
              return;
            }
            naver_script();

            if (selectedPlan.coupon_name && originalPlan) {
              navigate('/payment/method', {
                state: { selectedPlan: originalPlan, month },
              });
            } else {
              navigate('/payment/method', { state: { selectedPlan, month } });
            }
          }}
        >
          구매하기
        </S.ConfirmButton>
      </S.CardBottom>
      {openDropdown && (
        <RegionSelectModal
          select={selectedPlan}
          setSelect={setSelectedPlan}
          plans={plans}
          onClose={() => setOpenDropdown(false)}
        />
      )}
    </S.CardContainer>
  );
};

export default Premium;
